/**
 * 사용자-회사 관계 상수 정의
 * Feature 036: User-Company Relation
 * Feature 038: Company User Onboarding (Phase 1 - 역할 단순화)
 */

/**
 * 사용자-회사 관계 역할 (단순화된 2단계 구조)
 * - MANAGER: 회사 관리자 (멤버 승인/거절, 멤버 관리)
 * - USER: 일반 사용자 (기본 접근 권한)
 *
 * @migration 038-company-user-onboarding
 * - owner -> manager
 * - admin -> manager
 * - member -> user
 */
export enum UserCompanyRole {
  MANAGER = "manager",
  USER = "user",
}

/**
 * 가입 상태
 * - PENDING: 승인 대기
 * - APPROVED: 승인됨
 * - REJECTED: 거절됨
 */
export enum UserCompanyStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

/**
 * 역할 배열 (Typegoose enum 검증용, 하위 호환성)
 */
export const USER_COMPANY_ROLES = Object.values(UserCompanyRole);

/**
 * 상태 배열 (Typegoose enum 검증용, 하위 호환성)
 */
export const USER_COMPANY_STATUS = Object.values(UserCompanyStatus);
